<template>
  <div>
    <nav
      class="bg-white     lg:px-8 px-0 pt-2 shadow-md fixed w-screen self-start  h-16 opacity-75 z-40    flex align-middle justify-between   "
    >
      <div class="-mb-px w-screen block  flex justify-between   ">



<!--  BOUTON HOME        -->
          <div class="home w-1/6 flex ">
              <router-link
                      active-class="text-teal-dark  border-teal-dark font-bold text-xs w-full  "
                      to="/"
              >
        <a
          class="no-underline text-grey-dark   uppercase  font-bold text-xs py-3 lg:mr-8 lg:inline-block   align-middle mr-4"
          href="#"
        >

            <strong class="lg:visible  hidden lg:block">Home</strong>


            <div class=" visible lg:hidden ">

                <font-awesome-icon fixed-width
                class="text-2xl  ml-6   h-auto py-2"
                :icon="['fas', 'home']"
              />

            </div>

        </a>
              </router-link>
          </div>

<!--CATEGORIES-->



          <div class="categories w-full justify-center flex">
              <router-link
                      active-class="text-teal-500 border-b-2 border-teal-500 font-bold text-xs "
                      to="/vacances"
              >
        <p
          class="no-underline text-grey-dark border-b-2 border-transparent uppercase tracking-wide font-bold text-xs py-3 lg:mr-8 mr-2 lg:inline-block hidden  w-full  text-center"
          href="#"
        >

            Vacances

        </p>
              </router-link>

              <router-link
                      active-class="text-teal-500 border-b-2 border-teal-500 font-bold text-xs "
                      to="/anniversaire"
              >

        <a
          class="no-underline text-grey-dark border-b-2 border-transparent uppercase tracking-wide font-bold text-xs py-3 lg:mr-8 mr-2 lg:inline-block hidden  w-full  text-center "
          href="#"
        >

            Anniversaire

        </a>
              </router-link>
              <router-link
                      active-class="text-teal-500 border-b-2 border-teal-500 font-bold text-xs"
                      to="/mariage"
              >
        <a
          class="no-underline text-grey-dark border-b-2 border-transparent uppercase tracking-wide font-bold text-xs py-3 lg:mr-8 mr-2 lg:inline-block hidden w-full  text-center"
          href="#"
        >

            Mariage

        </a>
              </router-link>
              <router-link
                      active-class="text-teal-500 border-b-2 border-teal-500 font-bold text-xs "
                      to="/faq"
              >
        <a
          class="no-underline text-grey-dark border-b-2 border-transparent uppercase tracking-wide font-bold text-xs py-3 lg:mr-8 mr-2 lg:inline-block hidden w-full  text-center"
          href="#"
        >

            Contact / FAQs

        </a>
              </router-link>





      </div>







        <div class="block  flex  align-top text-grey-dark w-1/6 justify-end">

        <div class="lg:inline-flex  align-top text-grey-dark  hidden">
          <router-link
            active-class="text-teal-dark text-teal-500  border-teal-dark font-bold"
            to="/register"
          >
            <button
              class="bg-gray-300 hover:bg-gray-400  text-grey-dark   font-bold py-2 px-4 rounded-l"
            >
              Inscription
            </button>
          </router-link>
          <div class="text-blue-600">
            <router-link
              active-class="text-teal-500 no-underline  border-teal-dark font-bold"
              to="/login"
            >
              <button
                class="bg-gray-300 hover:bg-gray-400  font-bold py-2 px-4 rounded-r"
              >
                Connexion
              </button>
            </router-link>
          </div>
        </div>











<!--CATEGORIE MOBILE-->
        <div class="dropdown   lg:hidden  px-6   ">
          <button
            class="bg-gray-300 text-gray-700  py-2 px-4 rounded inline-flex items-center bg-gray-300 hover:bg-gray-400  text-grey-dark   font-bold py-2 px-4 rounded-l "
          >
            <span class="px-10">        <a
                    class="no-underline text-grey-dark border-b-2 border-transparent uppercase tracking-wide font-bold text-xs     text-center"
                    href="#"
            >

            Catégories

        </a></span>

            <svg
              class="fill-current h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path
                d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
              />
            </svg>
          </button>
          <ul class="dropdown-menu flex hidden text-gray-700 pt-1">
            <li class="">
              <router-link
                      active-class="text-teal-500 border-teal-500 font-bold"
                      to="/vacances">
                <a
                  class="rounded-t bg-gray-200 hover:bg-gray-400 py-2 px-4 block whitespace-no-wrap"

                  >Vacances</a
                ></router-link
              >
            </li>
            <li class="">
              <router-link
                      active-class="text-teal-500 border-teal-500 font-bold"
                      to="/anniversaire "
                ><a
                  class="bg-gray-200 hover:bg-gray-400 py-2 px-4 block whitespace-no-wrap"

                  >Anniversaire</a
                ></router-link
              >
            </li>

            <li class="">
              <router-link
                      active-class="text-teal-500 border-teal-500 font-bold"
                      to="/mariage"
                ><a
                  class="rounded-b bg-gray-200 hover:bg-gray-400 py-2 px-4 block whitespace-no-wrap"

                  >Mariage</a
                ></router-link
              >
            </li>

              <hr/>
              <li class="">
                  <router-link
                          active-class="text-teal-500 border-teal-500 font-bold"
                          to="/about"
                  ><a
                          class="rounded-b bg-gray-200 hover:bg-gray-400 py-2 px-4 block whitespace-no-wrap"

                  >Contact</a
                  ></router-link
                  >
              </li>

              <li class="">
                  <router-link
                          active-class="text-teal-500 border-teal-500 font-bold"
                          to="/faq"
                  ><a
                          class="rounded-b bg-gray-200 hover:bg-gray-400 py-2 px-4 block whitespace-no-wrap"

                  >FAQs</a
                  ></router-link
                  >
              </li>


              <hr/>

              <li class="">
                  <router-link
                          active-class="text-teal-500 border-teal-500 font-bold"
                          to="/login"
                  ><a
                          class="rounded-b bg-gray-200 hover:bg-gray-400 py-2 px-4 block whitespace-no-wrap text-grey-dark  text-blue-600  font-bold"

                  >Connexion</a
                  ></router-link
                  >
              </li>
              <li class="">
                  <router-link
                          active-class="text-teal-500 border-teal-500 font-bold"
                          to="/register"
                  ><a
                          class="rounded-b bg-gray-200 hover:bg-gray-400 text-grey-dark font-bold py-2 px-4 block whitespace-no-wrap"

                  >Inscription</a
                  ></router-link
                  >
              </li>
          </ul>
        </div>
      </div>



      </div>
    </nav>
  </div>

</template>

<script>
//Javascript to toggle the menu

export default {
  name: "NavBar"
};


</script>

<style scoped>
.dropdown:hover .dropdown-menu {
  display: block;
}
</style>
